import React from 'react';
import { Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GreeningBrandLabel } from './GreeningBrandLabel';

const GREENPLAT_URL = 'https://www.greenplat.com';

/** Assinatura padrão GreeningAI — mesmo padrão gráfico do envio de e-mail. */
export function GreeningAgentSignature() {
  const theme = useTheme();
  return (
    <>
      informação detectada pelo agente de <GreeningBrandLabel />
      {' - '}
      <Link
        href={GREENPLAT_URL}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{ color: theme.palette.success.main, fontWeight: 600 }}
      >
        GreenPlat
      </Link>
    </>
  );
}

export default GreeningAgentSignature;
